<template>
  <label class="ms-switch">
    <input type="checkbox" :value="value" :checked="value" :disabled="disabled" v-on="listeners">
    <span class="checkmark">
      <div class="ms-switch-bar"></div>
      <div
        class="ms-cricle-switch"
        :class="['ms-cricle-switch', {'ms-cricle-switch-popup':isPopup }]"
      ></div>
    </span>
    <span
      v-if="title"
      :class="['ms-checkbox--title', {'ms-checkbox--title-popup':isPopup }]"
    >{{title}}</span>
  </label>
</template>
<script>
export default {
	name: 'msSwitch',
	props: {
		value: {},
		title: {
			default: null,
			type: String
		},
		isPopup: {
			default: false,
			type: Boolean
		},
		disabled: {
			default: false,
			type: Boolean
		}
	},
	computed: {
		listeners() {
			return {
				click: event => {
					this.$emit('click', event);
				},
				input: event => {
					this.$emit('input', !this.value);
				},
				change: event => {
					this.$emit('change', this.value);
				}
			};
		}
	}
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msSwitch.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msSwitch.scss';
}
</style>